/**
 * @description 统一结构Schema
 * @param name 名称
 * @param description 描述
 * @param entitySets 实体集
 * @param entityTypes 实体类型
 * @param associations 关联集合
 * @date 2021-04-14
 * @author Wenxing Man
 */
export class NewSchema {
  name: string;
  description: string;
  entitySets: NewEntitySet[] = [];
  entityTypes: NewEntityType[] = [];
  associations: NewAssociation[] = [];
}
/**
 * @param code 实体集名
 * @param name 实体集语义化名
 * @param entityType 对应EntityType的code
 * @date 2021-04-14
 * @author Wenxing Man
 */
export class NewEntitySet {
  code: string;
  name: string;
  entityType: string;
}
/**
 * @param code 属性名
 * @param name 实体语义化名
 * @param master  是否是主实体
 * @param properties   属性集合
 * @param keys  主键集合
 * @param navigationPorperties 导航集合属性
 * @date 2021-04-14
 * @author Wenxing Man
 */
export class NewEntityType {
  code: string;
  name: string;
  master: boolean;
  properties: NewProperty[] = [];
  keys: String[] = [];
  navigationProperties: NewNavigationProperty[] = [];
}
/**
 * @param name 关联名称
 * @param masterType 主对象类型
 * @param childType 子对象类型
 * @param masterProperty 主对象字段
 * @param childProperty 从对象字段
 * @date 2021-04-14
 * @author Wenxing Man
 */
export class NewAssociation {
  name: string;
  masterType: string;
  childType: string;
  masterProperty: string;
  childProperty: string;
}
/**
 * @param code 属性名
 * @param name 属性语义化名
 * @param dataType 属性值类型
 * @param nullable 是否允许为空值
 * @param dafaultValue 属性默认值
 * @date 2021-04-14
 * @author Wenxing Man
 */
export class NewProperty {
  code: string;
  name: string;
  dataType: NewDataType;
  nullable: boolean;
  defaultValue: object;
}
/**
 * @param code 导航属性名称
 * @param name 导航属性语义化名
 * @param navigationName 导航对象的名称
 * @param navigationType 属性类型(EntitySet,EntityType)
 * @param relationShip 关联的对象
 * @date 2021-04-14
 * @author Wenxing Man
 */
export class NewNavigationProperty {
  code: string;
  name: string;
  navigationName: string;
  navigationType: NewNavigationType;
  relationShip: string;
}

/**
 * @description 数据类型的枚举
 */
export enum NewDataType {
  String = "String",
  Byte = "Byte",
  Boolean = "Boolean",
  Date = "Date",
  DateTime = "DateTime",
  Decimal = "Decimal",
  Integer = "Integer"
}

/**
 * @description 导航属性类型的枚举
 * @enum EntitySet EntitySet
 * @enum EntityType EntityType
 */
export enum NewNavigationType {
  EntitySet = "EntitySet",
  EntityType = "EntityType",
  EntityEnum = "EntityEnum"
}